import backend from "../api";
import {
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_CREATE_FAIL,
  ORDER_DETAILS_FAIL,
  ORDER_DETAILS_SUCCESS,
  ORDER_DETAILS_REQUEST,
  ORDER_LIST_MY_REQUEST,
  ORDER_LIST_MY_SUCCESS,
  ORDER_LIST_MY_FAIL,
  ORDER_LIST_MY_RESET,
} from "../constants/orderConstants";

export const createOrder = (order) => async (dispatch) => {
  try {
    dispatch({ type: ORDER_CREATE_REQUEST });
    let { data } = await backend.post("/order_pos", order);
    dispatch({ type: ORDER_CREATE_SUCCESS, payload: data });
  } catch (error) {
    if (error.response.data.message.includes('path "_id" for model "users"')) {
      dispatch({ type: ORDER_CREATE_FAIL, payload: "Customer not found" });
    } else {
      dispatch({
        type: ORDER_CREATE_FAIL,
        payload: error.response ? error.response.data.message : error.message,
      });
    }
  }
};

export const getOrder = (id) => async (dispatch) => {
  try {
    dispatch({ type: ORDER_DETAILS_REQUEST });
    let { data } = await backend.get(`/order_pos?_id=${id}`);
    dispatch({ type: ORDER_DETAILS_SUCCESS, payload: data.data[0] });
  } catch (error) {
    dispatch({
      type: ORDER_DETAILS_FAIL,
      payload: error.response ? error.response.data.message : error.message,
    });
  }
};

export const listMyOrders = (page = 1) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ORDER_LIST_MY_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const { data } = await backend.get(`/order_pos?merchant=${userInfo._id}&page=${page}`);

    dispatch({
      type: ORDER_LIST_MY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: ORDER_LIST_MY_FAIL,
      payload: message,
    });
  }
};
